import { CookieAuthConfiguration } from './environment.model'

export const authConfig: CookieAuthConfiguration = {
  meUrl: '/info/self',
  loginUrl: '/login',
  logoutUrl: '/logout',
}
